module.exports = __webpack_public_path__ + "a45037877b31a0c6356244e03a8247f5.png";


//////////////////
// WEBPACK FOOTER
// ./images/slide1.png
// module id = 275
// module chunks = 0